import { router } from 'expo-router';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H2Emphasized,
    Icon,
    ScreenContainer,
    UserSearchIcon,
    View,
    YStack,
} from 'smoothie';

import { useViewEvents } from '../../../../events/hooks/useViewEvents';

export const ApexAccountsUnderReview = () => {
    const { trackViewOnce } = useViewEvents();
    trackViewOnce('Roadmap/Go/ApexAccountsUnderReview');
    return (
        <ScreenContainer
            hasCloseButton={true}
            onClose={() => {
                router.navigate('/roadmap/go/start');
            }}
        >
            <YStack
                flex={1}
                gap={20}
                $md={{ minWidth: 400 }}
                maxWidth={500}
                height="100%"
                minHeight={300}
                justifyContent="space-between"
                paddingTop={64}
                paddingHorizontal={24}
            >
                <YStack flex={1} alignItems="center" gap={32}>
                    <View
                        alignSelf="center"
                        justifyContent="center"
                        alignItems="center"
                        height={80}
                        width={80}
                        borderRadius={16}
                        backgroundColor="$gray300"
                    >
                        <Icon
                            icon={UserSearchIcon}
                            color="$black"
                            backgroundColor="$gray300"
                            size={40}
                        />
                    </View>
                    <H2Emphasized textAlign="center" paddingHorizontal={32}>
                        We&apos;re reviewing your information
                    </H2Emphasized>
                    <BodyMediumRegular textAlign="center">
                        A Fruitful team member may reach out for additional
                        information.
                    </BodyMediumRegular>
                </YStack>
                <YStack>
                    <Button
                        onPress={() => {
                            router.navigate('/home');
                        }}
                        text="Back to home"
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                    />
                </YStack>
            </YStack>
        </ScreenContainer>
    );
};
